import { Buffer } from 'buffer';
import { svgToPng } from '../utils/svg';

global.Buffer = Buffer;

self.onmessage = async message => {
  const { url, key, options } = message.data;
  fetch(url)
    .then(async res => {
      if (!res.ok) {
        throw Error();
      }
      const contentType = url.startsWith('data:')
        ? /data:(.*?)[;,]/.exec(url)?.[1]
        : res.headers.get('Content-Type');
      switch (contentType) {
        case 'image/svg+xml':
          return svgToPng(await res.text(), options.size);
        case 'image/png':
        case 'image/jpeg':
        case 'image/jpg': // Invalid content type but sadly returned by some NFTs
        case 'image/bmp':
        case 'image/gif':
        case 'image/webp':
          return res.blob();
        default:
          throw Error();
      }
    })
    .then(blob => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (...e) => reject(...e);
        reader.readAsDataURL(blob);
      });
    })
    .then(value => {
      self.postMessage({
        key,
        value,
      });
    });
};
